import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import aiModelFiltersSignal, {
	setAiModelFilters,
} from '@UI/Pages/Administration/AiEngines/Sections/ModelsSection/Filters/Signals/aiModelFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly options: ReadonlyArray<{ readonly id: number; readonly label: string }>;
};

const ProviderFilter: React.FC<Props> = ({ options }) => {
	const currentFilters = useSignalValue(aiModelFiltersSignal);

	const handleProviderChange = React.useCallback((providerId: number | null) => {
		setAiModelFilters(aiModelFiltersSignal.peek().setProviderId(providerId));
	}, []);

	return (
		<Dropdown<number>
			name="aiModelProvider"
			label="Fournisseur"
			isLabelHidden
			placeholder="Tous les fournisseurs"
			options={options}
			optionLabel="label"
			optionValue="id"
			showClear
			value={currentFilters.providerId}
			onChange={handleProviderChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default ProviderFilter;
